<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  placeholder: string
  modelValue: string
}
const props = withDefaults(defineProps<Props>(), {
  placeholder: ''
})
const myTextarea = ref(null);
const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()
const inputData = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})

const focusTextarea = async () => {
  await nextTick();
  if (myTextarea.value) {
    myTextarea.value.focus();
  }
};
</script>

<template>
  <div class="textarea__wrap">
    <textarea
      class="textarea"
      v-model="inputData"
      :placeholder="placeholder" ref="myTextarea" @click="focusTextarea"></textarea>
    <div class="textarea__icon"><slot /></div>
  </div>
</template>

<style scoped lang="scss">
.textarea {
  width: 100%;
  resize: none;
  height: 88px;

  padding: 16px;
  color: $primary-text;

  border-radius: 8px;
  border: 1.5px solid $ui-gray-1;
  background: $white;

  &:focus {
    background-color: $sub-green;
    border-color: $primary-green;
  }

  @include h5-2;
  &::placeholder {
    color: $sub-text;
    opacity: 1;
  }

  &__wrap {
    position: relative;
  }

  &__icon {
    pointer-events: none;
    position: absolute;
    top: 16px;
    right: 16px;
  }
}
</style>
